// api/auth.js
import apiClient from "./client";

export const authApi = {
  register: (data) => apiClient.post("/api/auth/register", data),
  login: (data) => apiClient.post("/api/auth/login", data),
  me: () => apiClient.get("/api/auth/me"),
};

// Token helpers
export const saveAuth = (token, user) => {
  localStorage.setItem("sc_token", token);
  localStorage.setItem("sc_user", JSON.stringify(user));
};

export const clearAuth = () => {
  localStorage.removeItem("sc_token");
  localStorage.removeItem("sc_user");
};

export const getUser = () => {
  try {
    return JSON.parse(localStorage.getItem("sc_user"));
  } catch {
    return null;
  }
};
export const getUserTier = () => getUser()?.tier || "free";

export const isLoggedIn = () => !!localStorage.getItem("sc_token");
